import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetKnowledgeForCandidateResponse extends BackendResponse {
  items: Knowledge[];
}

export const getKnowledgeForCandidate =
  withNextApi<GetKnowledgeForCandidateResponse>(
    "/cvp/CvpGetKnowledgeForCandidate"
  );

export interface Knowledge {
  id: number;
  idCandidate: number;
  level: number;
  knowledgeType: string;
  knowledgeTypeId: number;
  knowledgeFolder: string;
  expirationDate: string | null;
  comment: string;
}
